import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import moment from 'moment-timezone';



import { WsDecodeFilters } from "../components/DecodeFilter";
import { Loading } from "../../Shared";
import { WipTableReportMantineV6 } from "../../../wip/TableReportMantineV6";
import { WsAppContext } from "../../AppContext";




const DecodeTableReport=  (props: {}) => {

  const appContext = useContext(WsAppContext);

  const classList: string[] = [ 'decode-hwb', 'ws-deliver-decode-score-dashboard' ];

  return(
    <div className={classList.join(' ')}>

      {
        [ 'avanade', 'hwb', 'nestle' ].includes(`${appContext?.theme}`)
        &&
        <>
          <WsDecodeFilters
            defaultValues={{
              regionalPartnershipId: '',
              localAuthorityId: '',
              schoolTypeId: '',
              schoolId: ''
            }}
            visible={{
              DateRange:           true,
              RegionalPartnership: true,
              LocalAuthority:      false,
              SchoolType:          true,
              School:              false,
            }}
          />
        </>
      }

      {/* <WipTableReportMantineV6 name="Usage Indicators" description="Usage indicators provides a table report summarizing MFA/sign-in overview, usage highlights, service activity, and 360 tools engagement." /> */}

      <WipTableReportMantineV6 name="Usage Indicators" description="Usage indicators provides a table report summarizing Copilot Usage, NesGPT, Enterprise Services and 360 tools engagement." />

    </div>
  );
};




export {
  DecodeTableReport
};
